import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable'
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination'
import { handlePaginationEntries } from '../../../../utils/pagination'
import { ErrorToast, SuccessToast } from '../../../../utils/toast'
import { useSelector } from 'react-redux'
import { hasPrivilege } from '../../../../utils/privileges'
import Loader from '../../../../Components/Loader/Loader'
import './CompletedScheduleTableStyle.css'
import CustomConfirmModal from '../../../../Components/custom_components/CustomConfirmModal/CustomConfirmModal'
import CompletedScheduleFilter from '../CompletedScheduleSearchFilter/CompletedScheduleSearchFilter'
import { get_all_completed_schedules_with_pagination, schedule_move_to_client, schedule_move_to_finance } from '../../../../config/ScheduleReportApis/scheduleReportApis'
import { getUserData } from '../../../../utils/localStorage'

function CompletedScheduleTable() {
    const privileges = useSelector((state) => state.privileges.privileges);
    const userData = getUserData()

    // State variables for managing schedule data, pagination, and modal states
    const [scheduleListing, setScheduleListing] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });
    const [refresh, setRefresh] = useState(false);

    const [filterValues, setFilterValues] = useState({
        ScheduleCode: '',
        Survey_from_date: '',
        Survey_end_date: '',
        TechnologyId: '',
        WorksiteId: '',
        // EmployeeId: '',
        EquipmentID: '',
        movetofinance: 0,
    }); // Define filter values state
    const [isLoading, setIsLoading] = useState(false); // Loader state

    const [showCheckBox, setShowCheckBox] = useState(filterValues?.movetofinance == 0); //movetofinance =0 means not moved to finance

    const [submitModal, setSubmitModal] = useState({
        isOpen: false,
        id: '',
    });
    const [submitToFinance, setSubmitToFinance] = useState({
        isOpen: false,
        id: '',
    });
    const [selectedIds, setSelectedIds] = useState([]); //FOR FORWARD THE SCHEDULES ID INTO FINANCE
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);


    // Fetch schedule data on page change or refresh
    useEffect(() => {
        fetchCompletedSchedules();
    }, [pageNumber, totalItemPerPage, filterValues, refresh]);

    // Fetch schedule data from API
    const fetchCompletedSchedules = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        // Append filter values to formData
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_all_completed_schedules_with_pagination(formData);

            if (response?.status === "success") {
                const data = response.data;
                setScheduleListing(data.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setScheduleListing([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Schedule ", key: "ScheduleCode" },
        { title: "Employee name", key: "EmployeeName" },
        { title: "Technology", key: "technologyname" },
        { title: "Worksite", key: "ScheduleWorksite" },
        { title: "Client", key: "ClientName" },
        { title: "Project", key: "ProjectName" },
        { title: "From", key: "ScheduleStartDate" },
        { title: "To", key: "ScheduleEndDate" },
        { title: "Man Days", key: "SchedulemanDays" },
    ]

    // Map the schedule data into table rows
    const rows = () => scheduleListing?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        id: item.id,
        ScheduleCode: item.ScheduleCode,
        technologyname: item?.Technologyname,
        ScheduleCode: item.ScheduleCode,
        ScheduleStartDate: item?.ScheduleStartDate,
        ScheduleEndDate: item?.ScheduleEndDate,
        ScheduleWorksite: item.ScheduleWorksite,
        SchedulemanDays: item.SchedulemanDays,
        EmployeeName: item.EmployeeName,
        ClientName: item.ClientName,
        ProjectName: item.ProjectName,
        ScheduleStatus: item?.ScheduleStatus || false
    }));

    // FOR FORWARD SCHEDULE INTO CLIENT OR FINANCE
    const handleForwardToFinance = async () => {
        const params = {
            manDaysId: selectedIds, //  submitModal?.id
            move_status: 1
        }
        try {
            setIsButtonDisabled(true);
            const response = await schedule_move_to_finance(params)
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message)
                setSelectedIds([]) //clear tge selected id after successfull forward
                handlSubmitTofinanceModal(false, "")
                setRefresh(!refresh)
            } else {
                ErrorToast(response?.data?.message || `Something Went Wrong!`)
            }
        } catch (error) {

        } finally {
            setIsButtonDisabled(false);

        }

    }
    // reports forward to client
    const handleForwardToClient = async () => {
        const params = {
            schedulId: JSON.stringify(selectedIds), //  submitModal?.id
            move_status: 1
        }
        try {
            setIsButtonDisabled(true);
            const response = await schedule_move_to_client(params)
            if (response?.data?.status === "success") {
                SuccessToast(response?.data?.message)
                setRefresh(!refresh)
                handlSubmitModal(false, "")
            } else {
                ErrorToast(response?.data?.message || `Something Went Wrong!`)
                // }
            }
        } catch (error) {

        } finally {
            setIsButtonDisabled(false);

        }

    }


    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);

    // Handle search filter changes and update filter values
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
        setShowCheckBox(filterValues?.movetofinance == 0)
    };
    // Function to handle HIDE/SHOW DELETE MODAL
    const handlSubmitModal = (isOpen, id = '') => {
        setSubmitModal({ isOpen, id })
    }

    // Function to handle HIDE/SHOW DELETE MODAL
    const handlSubmitTofinanceModal = (isOpen, id = '') => {
        setSubmitToFinance({ isOpen, id })
    }

    // FOR SELECET ALL FUNCTION
    const handleSelectAll = () => {
        //  Only include rows where ScheduleStatus is not present OR is true
        const selectableIds =
            rows()
                ?.filter(
                    (row) =>
                        !row?.hasOwnProperty("ScheduleStatus") || row.ScheduleStatus === true
                )
                .map((row) => row.id) || [];

        setSelectedIds((prevSelected) => {
            const allSelected = selectableIds.every((id) =>
                prevSelected.includes(id)
            );

            if (allSelected) {
                // Already all selected → clear 
                return prevSelected.filter((id) => !selectableIds.includes(id));
            }

            // Otherwise → select all
            return Array.from(new Set([...prevSelected, ...selectableIds]));
        });
    };

    // FOR SELECT SCHEDULE BY ROW
    const handleSelectRow = (id) => {
        setSelectedIds((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((itemId) => itemId !== id)
                : [...prevSelected, id]
        );
    };

    const handleClearSelectedIds = () => {
        setSelectedIds([])
    }

    // SUPER ADMIN 1 ADDMIN 3
    const isAdminLogin = userData?.RoleId === 1 || userData?.RoleId === 3;
    return (
        <>
            <div className='workforce-management-table-container'>
                <CompletedScheduleFilter
                    tableTitle={`${isAdminLogin ? `Man-Days (Supervisor)` : `Man-Days`}`}
                    searchFilter={handleSearchFilter}
                    isSendPermission={selectedIds?.length > 0}
                    handlSubmitModal={handlSubmitModal}
                    handlSubmitTofinanceModal={handlSubmitTofinanceModal}
                    handleClearSelectedIds={handleClearSelectedIds}

                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}
                />
                <div>
                    <CustomTable
                        columns={columns}
                        rows={isLoading ? [] : rows()}
                        isCheckbox={showCheckBox && rows()?.length > 0} //not show the select all check  box when no data
                        selectedIds={selectedIds}
                        handleSelectRow={handleSelectRow}
                        handleSelectAll={handleSelectAll}
                        isLoading={isLoading}
                    />
                </div>
                <div className='bottom-container'>
                    {isLoading ? <Loader /> : <CustomBottomPagination
                        items_per_page={totalItemPerPage}
                        current_page={pageNumber}
                        total_page_count={totalPages}
                        on_change_value={handlePageChange}
                        on_page_count_update={handleItemPageCountChange}
                        pagination={pagination}
                    />}
                </div>
            </div>

            {/* Submit to Finance Department */}
            <CustomConfirmModal
                custom_text={'Want to submit this to the Finance Department?'}
                open_modal={submitToFinance?.isOpen}
                close_modal={handlSubmitTofinanceModal}
                confirm_function={handleForwardToFinance}
                isButtonDisabled={isButtonDisabled}

            />

            {/* Submit to Reports to client */}
            <CustomConfirmModal
                custom_text={'Want to submit this to the Client?'}
                open_modal={submitModal?.isOpen}
                close_modal={handlSubmitModal}
                confirm_function={handleForwardToClient}
                isButtonDisabled={isButtonDisabled}

            />
        </>
    )
}

export default CompletedScheduleTable